var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var { inDays } = require("./util");

console.clear();

var raw_data = [];
var per_capita = [];
var allStates = [];
var filterOut = [
  "American Samoa",
  "Guam",
  "Marshall Islands",
  "Micronesia",
  "Northern Marianas",
  "Palau",
  "Virgin Islands",
  "Grand Princess",
  "Diamond Princess"
];
var pymChild;
var navElement;
var stateSelection = "all states";
var toggleSelection = "raw data";
var allData = [];
var activeView = LABELS.states_chart1.toLowerCase();

var {
  COLORS,
  getAPMonth,
  classify,
  makeTranslate,
  wrapText,
  fmtComma
} = require("./lib/helpers");
var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-shape/dist/d3-shape.min"),
  ...require("d3-interpolate/dist/d3-interpolate.min"),
  ...require("d3-transition/dist/d3-transition.min"),
  ...require("d3-force/dist/d3-force.min")
};

var fmtYearAbbrev = d => (d.getFullYear() + "").slice(-2);
var fmtYearFull = d => d.getFullYear();
var fmtDayYear = d => d.getDate() + ", " + d.getFullYear();
var fmtDateFull = d => getAPMonth(d) + " " + fmtDayYear(d).trim();

//Initialize graphic
var onWindowLoaded = function() {
  formatData();
  render();
  // update({
  //   toggleSelection,
  //   stateSelection
  // })

  window.addEventListener("resize", render);

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

// Format data
var formatData = function() {
  var today = LABELS.dateUpdatedCode; // get today's date
  var daysSinceFirst = -1;

  var states = {};
  for (var row of TIMESERIES_DATA) {
    var s = row.Province_State;
    if (!s || filterOut.includes(s)) continue;
    var [y, m, d] = row.Report_Date_String.split("/");
    var reported = [m, d, y].join("/");
    var day = inDays(reported);
    var count = row.Confirmed;
    if (!states[s] && count >= 100)
      states[s] = {
        name: s,
        values: [],
        first100: day
      };
    var state = states[s];
    if (!state) continue;
    state.values.push({
      date: day - state.first100,
      amt: count
    });
  }

  // // Raw data
  // for (var column in RAW_DATA[0]) {
  //   if (column == "date" || column == "United States") continue;

  //     raw_data.push({
  //       name: column,
  //       values: RAW_DATA.filter(d => d[column] >= 100).map(d => ({ // only get data from 100th case
  //         date: daysSinceFirst += 1,
  //         amt: d[column]
  //       }))
  //     });
  //   daysSinceFirst = -1; // count days since 100th case
  // }

  // raw_data = raw_data.filter(r => !filterOut.includes(r.name));

  raw_data = Object.keys(states).map(s => states[s]);

  // Per capita data
  for (var i = 0; i < raw_data.length; i++) {
    per_capita.push({
      name: raw_data[i].name,
      values: raw_data[i].values.map(d => ({
        date: d.date,
        amt: (d.amt / POPULATION[raw_data[i].name]) * 100000 // match population data in sheet to state and calc per capita
      }))
    });
  }

  allData.push({ raw_data, per_capita }); // push into one big dataset

  // Dropdown groups
  allStates = raw_data.map(d => d.name);
  allStates.unshift("All States");

  // console.log(raw_data, per_capita, allStates, allData);
};

// Render graphics
var render = function() {
  // Assign nav element to id
  navElement = d3.select("#toggle-button");

  // // Remove raw/per capita toggle before redraw
  // navElement.html("");

  // // Raw/per capita toggle
  // navElement
  //   .insert('div','*')
  //   .attr('class', 'nav')
  //   .selectAll('button')
  //   .data([ LABELS.states_chart1, LABELS.states_chart2 ])
  //   .enter()
  //     .append('button')
  //       .text(function(d) {
  //         return d;
  //       })
  //       .attr('id', function(d) {
  //         return classify(d);
  //       });

  // Set up chart
  var container = "#line-chart";
  var element = document.querySelector(container);
  var width = element.offsetWidth;

  var dateColumn = "date";
  var valueColumn = "amt";

  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 3 : 9;

  var margins = {
    top: 50,
    right: 85,
    bottom: 50,
    left: 50
  };

  var ticksX = 10;
  var ticksY = 3;
  var roundTicksFactor = 5;

  // Mobile
  if (isMobile.matches) {
    ticksX = 5;
    ticksY = 3;
    margins.right = 85;
    margins.top = 50;
  }

  // Calculate actual chart dimensions
  var chartWidth = width - margins.left - margins.right;
  var chartHeight =
    Math.ceil((width * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(container);
  containerElement.html("");

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Initialize x and y axis
  var xScale = d3.scaleLinear().range([0, chartWidth]);
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .ticks(ticksX);

  var yScale = d3.scaleLog().range([chartHeight, 0.1]);
  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    .tickFormat(d => fmtComma(d));

  // Append x and y axis to chart
  chartElement
    .append("g")
    .attr("class", "x axis xAxis")
    .attr("transform", makeTranslate(0, chartHeight));

  chartElement.append("g").attr("class", "y axis yAxis");

  // Add x axis label
  chartElement
    .append("g")
    .attr("class", "state-label")
    .append("text")
    .attr("y", chartHeight + 40)
    .attr("x", xScale(0))
    .text("Days since 100th case ⟶");

  // Initialize the part of the chart that will update with new data/selections
  var updatingLines = chartElement.append("g").attr("class", "state-lines");
  var updatingValues = chartElement.append("g").attr("class", "state-values");

  // Update function that takes a dataset as input and updates the chart
  var update = function(config) {
    // Remove raw/per capita toggle before redraw
    navElement.html("");

    // Create new data from selection + sort in ascending order
    var data = allData[0][config.toggleSelection.replace(" ", "_")].sort(
      function(a, b) {
        return (
          a.values[a.values.length - 1].amt - b.values[b.values.length - 1].amt
        );
      }
    );

    // Find the top two states to display
    var labelMin =
      data[data.length - 2].values[data[data.length - 2].values.length - 2].amt;

    // Find the max to display
    var labelMax =
      data[data.length - 1].values[data[data.length - 1].values.length - 1].amt;

    // console.log(data, labelMin, labelMax);

    // Find max date for x axis
    var dates = 0;
    for (var i = 0; i < data.length; i++) {
      var state_dates = data[i].values.map(d => d.date);
      if (state_dates[state_dates.length - 1] > dates) {
        dates = state_dates[state_dates.length - 1];
      }
    }

    // Update x axis + add grid
    var extent = [0, dates];
    xScale.domain(extent);
    d3.transition()
      .selectAll(".xAxis")
      .duration(1000)
      .call(
        xAxis
          .ticks(ticksX)
          .tickSize(-chartHeight, 0, 0)
          .tickPadding(10)
      );

    var values = data.reduce(
      (acc, d) => acc.concat(d.values.map(v => v[valueColumn])),
      []
    );

    var floors = values.map(
      v => Math.floor(v / roundTicksFactor) * roundTicksFactor
    );
    var min = Math.min.apply(null, floors);

    if (min >= 100) {
      min = 100;
    } else {
      min = 0.1;
    }

    var ceilings = values.map(
      v => Math.ceil(v / roundTicksFactor) * roundTicksFactor
    );
    var max = Math.max.apply(null, ceilings);
    // var labelMin = max * 0.09;
    if (config.toggleSelection == "raw data") {
      max = max;
    } else {
      max = 1000;
    }

    // Update y axis + add grid
    yScale.domain([min, max]);
    d3.transition()
      .selectAll(".yAxis")
      .duration(1000)
      .call(
        yAxis
          .ticks(ticksY)
          .tickSize(-chartWidth, 0, 0)
          .tickPadding(10)
      );

    var colorScale = d3
      .scaleOrdinal()
      .domain(
        data.map(function(d) {
          return d.name;
        })
      )
      .range([
        COLORS.red3,
        COLORS.blue1,
        COLORS.yellow3,
        COLORS.blue3,
        COLORS.teal3,
        COLORS.orange3
      ]);

    // Render lines to chart.
    var line = d3
      .line()
      .x(d => xScale(d[dateColumn]))
      .y(d => yScale(d[valueColumn]));

    var lastItem = d => d.values[d.values.length - 1];

    // Define updating group
    var u = updatingLines.selectAll("path").data(data);

    // Remove old data
    u.exit().remove();

    // Update data
    u.enter()
      .append("path")
      .merge(u)
      .attr("class", d => "line " + classify(d.name))
      .attr("fill", "none")
      .attr("stroke", function(d) {
        if (config.toggleSelection == "raw data") {
          if (
            (lastItem(d) && lastItem(d).amt >= labelMax) ||
            (d.name == "Washington" && config.stateSelection == "all states")
          ) {
            // return colorScale(d.name);
            return COLORS.orange3;
          } else if (
            (lastItem(d) && d.name.toLowerCase() == config.stateSelection) ||
            lastItem(d).amt >= labelMax
          ) {
            return COLORS.orange3;
          } else {
            return "rgba(216, 216, 216, 0.5)";
          }
        } else {
          if (
            (lastItem(d) && lastItem(d).amt >= labelMax) ||
            (d.name == "Washington" && config.stateSelection == "all states")
          ) {
            // return colorScale(d.name);
            return COLORS.teal3;
          } else if (
            (lastItem(d) && d.name.toLowerCase() == config.stateSelection) ||
            lastItem(d).amt >= labelMax
          ) {
            return COLORS.teal3;
          } else {
            return "rgba(216, 216, 216, 0.5)";
          }
        }
      })
      .attr("d", d => line(d.values))
      .attr("class", function(d) {
        if (
          d.name == "New York" ||
          (d.name == "Washington" && config.stateSelection == "all states")
        ) {
          return "highlight";
        } else if (d.name.toLowerCase() == config.stateSelection) {
          return "highlight";
        } else {
          return classify(d.name);
        }
      });

    // Value labels
    var labels = updatingValues.selectAll("text").data(data);

    labels.exit().remove();
    labels.attr("y", d => d.y);
    labels
      .enter()
      .append("text")
      .merge(labels)
      .attr("x", function(d) {
        if (lastItem(d)) {
          return xScale(lastItem(d)[dateColumn]) + 10;
        }
      })
      .attr("y", function(d) {
        if (lastItem(d)) {
          return yScale(lastItem(d)[valueColumn]);
          // return d.y;
        }
      })
      .text(function(d) {
        // if (lastItem(d) && lastItem(d).amt >= labelMax || d.name == "Washington" && config.stateSelection == "all states") {
        var cases = `${lastItem(d)
          .amt.toFixed(0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        return d.name + ": " + cases;
        // } else if (lastItem(d) && d.name.toLowerCase() == config.stateSelection || lastItem(d).amt >= labelMax) {
        //     var cases = `${lastItem(d).amt.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        //     return d.name + ": " + cases;
        // }
      })
      .attr("class", function(d) {
        if (
          d.name == "New York" ||
          (d.name == "Washington" && config.stateSelection == "all states")
        ) {
          return "highlight-label";
        } else if (d.name.toLowerCase() == config.stateSelection) {
          return "highlight-label highlight";
        } else {
          return "hide-label label-" + classify(d.name);
        }
      })
      .call(wrapText, margins.right - 25, 13);

    // toggle
    navElement
      .insert("div", "*")
      .attr("class", "nav")
      .selectAll("button")
      .data([LABELS.states_chart1, LABELS.states_chart2])
      .enter()
      .append("button")
      .text(function(d) {
        return d;
      })
      .attr("id", function(d) {
        return classify(d);
      });

    var navButtons = document.querySelectorAll(".nav button");
    navButtons.forEach(function(d, i) {
      d.addEventListener("click", onButtonClicked);
    });

    // Dropdown
    var stateMenu = d3.select("#dropdown");

    stateMenu
      .selectAll("option")
      .data(allStates)
      .enter()
      .append("option")
      .text(d => d)
      .attr("value", d => d);

    stateMenu.on("change", function() {
      var section = document.getElementById("dropdown");
      stateSelection = section.options[
        section.selectedIndex
      ].value.toLowerCase();
      // console.log(stateSelection);

      update({
        toggleSelection,
        stateSelection
      });

      d3.selectAll(".highlight").moveToFront();
    });
  };

  var onButtonClicked = function(event) {
    var btn = d3.select(this);
    var selected = btn.attr("id");
    activeView = selected;
    // console.log(btn._groups[0][0]);

    d3.selectAll(".active").classed("active", false);

    if (selected == "total") {
      toggleSelection = "raw data";
      update({
        toggleSelection,
        stateSelection
      });
      // console.log(toggleSelection);
    } else {
      toggleSelection = "per capita";
      update({
        toggleSelection,
        stateSelection
      });
      // console.log(toggleSelection);
    }
    var btnChange = btn._groups[0][0];
    d3.select(btnChange).classed("active", true);
    // btnChange.classList.add("active");
    // btn.classed("active", true);

    d3.selectAll("." + stateSelection.replace(" ", "-")).moveToFront();
  };

  // On window load, run update function on raw totals dataset
  update({
    toggleSelection,
    stateSelection
  });

  // This is supposed to activate the button states but it's not working right now
  document.querySelector("button#" + activeView).click();

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

//  *
// * Select an element and move it to the front of the stack
// */
d3.selection.prototype.moveToFront = function() {
  return this.each(function() {
    this.parentNode.appendChild(this);
  });
};

//Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
